<template>

    <router-view class="vue-router-view"></router-view>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'ba-company-root',
    methods: {
      ...mapActions('content', {loadContent: 'load'}),
      ...mapActions('settings', {loadSettings: 'load'}),
    },
    mounted () {
      let companyId = this.$route.params.companyId
      this.loadContent({companyId})
      this.loadSettings({companyId})
    }
  }
</script>

<style scoped>

</style>